const preDefinedSortForLeague = [
  "TurkiyeSuperLig",
  "EnglandPremierLeague",
  "GermanyBundesliga",
  "ItalySerieA",
  "SpainLaLiga",
];

export const sortLeaguesData = (leagues, isFixedMenu = false) => {
  if (isFixedMenu) {
    return Object.keys(leagues);
  }
  const leagueKeys = Object.keys(leagues ?? {});
  const preDefinedData = preDefinedSortForLeague.filter((_key) =>
    leagueKeys.includes(_key)
  );
  const sortedData = leagueKeys
    .filter((_key) => !preDefinedSortForLeague.includes(_key))
    .sort((a, b) => a.localeCompare(b));
  return [...preDefinedData, ...sortedData];
};
